import type {
  ThreeDViewerOrderableAssemblyPart,
  ThreeDViewerPartSearchSource
} from '@/interfaces/library'

export function getThreeDPartSourceKey (source: ThreeDViewerPartSearchSource) {
  const part = source.part
  if (part.id != null) return `id:${part.id}`

  return `part:${part.supplierKey ?? ''}:${part.partNumber ?? ''}`
}

export function getLockedAssemblySelectionRedirects (
  source: ThreeDViewerPartSearchSource[]
) {
  return source.reduce<Record<number, number>>((redirects, item) => {
    Object.entries(item.lockedAssemblyParentIds ?? {}).forEach(([childId, parentId]) => {
      const childDbId = Number(childId)
      if (Number.isInteger(childDbId) && Number.isInteger(parentId) && childDbId !== parentId) {
        redirects[childDbId] = parentId
      }
    })
    return redirects
  }, {})
}

export function getLockedAssemblyAncestors (
  dbId: number,
  redirects: Record<number, number>
) {
  const ancestors: number[] = []
  const visited = new Set<number>([dbId])
  let childId = dbId

  while (redirects[childId] != null) {
    const parentId = redirects[childId]
    if (visited.has(parentId)) break

    ancestors.push(parentId)
    visited.add(parentId)
    childId = parentId
  }

  return ancestors
}

export function getOrderableLockedAssemblyParts (
  assemblyDbId: number,
  source: ThreeDViewerPartSearchSource[],
  redirects: Record<number, number>
) {
  const parts = new Map<string, ThreeDViewerOrderableAssemblyPart>()

  source.forEach((item) => {
    const part = item.part
    if (part.deleted === true || part.visible !== true || part.orderable !== true) return

    const elementIds = item.elementIds.filter(elementId =>
      getLockedAssemblyAncestors(elementId, redirects).includes(assemblyDbId)
    )
    if (elementIds.length === 0) return

    const key = getThreeDPartSourceKey(item)
    const existing = parts.get(key)
    parts.set(key, {
      elementIds: [...new Set([...(existing?.elementIds ?? []), ...elementIds])],
      key,
      part,
      pricingLoaded: false
    })
  })

  return [...parts.values()]
}
